import _ from 'lodash';
import { getRequest } from '../../Common/network-call';
import { TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FETCH_ORDERS,
  FIELDS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';
import {
  ALLOWED_FEATURE_KEYS,
  OVERVIEW_FEATURE_FETCH_LIMITS
} from '../../../constants/section-constants/common-constants';

export const ALL_SPEAKERS_LIST = 'ALL_SPEAKERS_LIST';
export const ALL_SPONSORS_LIST = 'ALL_SPONSORS_LIST';
export const ALL_EXHIBITORS_LIST = 'ALL_EXHIBITORS_LIST';
export const ALL_SESSION_LIST = 'ALL_SESSION_LIST';
export const SEEN_EVENT_ADS = 'SEEN_EVENT_ADS';

export const fetchAllSpeakers_Overview = (
  session,
  extra = {
    sortBy: 'az',
    appTabId: 0,
    featured: false
  },
  callback = null
) => {
  const fetchFilter = encodeURI(`(eventid=${session.eventid})`);

  const orderBy = `${extra?.featured ? `featured,` : ''}${
    _.isEqual(extra?.sortBy, 'az')
      ? FETCH_ORDERS.speaker.name
      : FETCH_ORDERS.speaker.random
  }`;
  const fetchOrder =
    OVERVIEW_FEATURE_FETCH_LIMITS[ALLOWED_FEATURE_KEYS.speaker];
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.speaker}?include_count=true&fields=${FIELDS.speaker.mediumInfo}&filter=${fetchFilter}&order=${orderBy}&limit=${fetchOrder}&offset=0`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        dispatch({
          type: ALL_SPEAKERS_LIST,
          payload: { resource: res.resource, count: res.meta.count }
        });
        callback && callback({ success: 1 });
      },
      error => {
        callback && callback({ success: 0 });
      }
    );
  };
};

/**
 * API inline orders are not affecting the response, may be due to some backend changes.
 * Local ordering logic added.
 * Old code kept for reference until next ticket raised.
 */
export const fetchAllSponsors_Overview = (
  session,
  extra = {
    sortBy: 'az',
    appTabId: 0
  },
  callback = null
) => {
  const fetchFilter = encodeURI(`(eventid=${session.eventid})`);
  // const orderBy = _.isEqual(extra?.sortBy, 'randomly')
  //   ? FETCH_ORDERS.sponsor.random
  //   : FETCH_ORDERS.sponsor.name;
  const fetchLimit =
    OVERVIEW_FEATURE_FETCH_LIMITS[ALLOWED_FEATURE_KEYS.sponsor];
  // const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sponsor}?include_count=true&fields=${FIELDS.sponsor.mediumInfo}&related=membershiptype_by_categoryid&filter=${fetchFilter}&order=${orderBy}&limit=${fetchLimit}&offset=0`;
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sponsor}?include_count=true&fields=${FIELDS.sponsor.mediumInfo}&related=membershiptype_by_categoryid&filter=${fetchFilter}&limit=${fetchLimit}&offset=0`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        /**
         * Processing response:
         *
         * Initial
         * First stage => Grouped based on category
         * Second stage => Grouped list ordered as per settings (az/random)
         *
         * Preparing list of categories only, as per their set priority index
         *
         * Doing flatmap of the grouped sponsor response, based on category priority index
         *
         * Finally applying last ordering for featured item
         */

        // Initial
        const groupedSponsors = _.chain(res?.resource)
          .groupBy(ea => ea?.membershiptype_by_categoryid?.membershiptitle)
          .mapValues(groupItems =>
            _.orderBy(
              groupItems,
              _.isEqual(extra?.sortBy, 'randomly')
                ? FETCH_ORDERS.sponsor.randomInternal.fields
                : FETCH_ORDERS.sponsor.nameInternal.fields,
              _.isEqual(extra?.sortBy, 'randomly')
                ? FETCH_ORDERS.sponsor.randomInternal.order
                : FETCH_ORDERS.sponsor.nameInternal.order
            )
          )
          .value();

        // Category list
        const orderedGroupTitles = _.chain(res?.resource)
          .map(ea => ea?.membershiptype_by_categoryid)
          .uniqBy('id')
          .orderBy('priorityindex', 'asc')
          .map('membershiptitle')
          .value();

        // Final list + Featured ordering
        const list = _.chain(orderedGroupTitles)
          .flatMap(title => groupedSponsors[title] || [])
          .orderBy('featured', 'desc')
          .value();

        dispatch({
          type: ALL_SPONSORS_LIST,
          payload: { resource: list, count: res.meta.count }
        });
        callback && callback({ success: 1 });
      },
      error => {
        callback && callback({ success: 0 });
      }
    );
  };
};

export const fetchAllExhibitors_Overview = (
  session,
  extra = {
    sortBy: 'az',
    appTabId: 0
  },
  callback = null
) => {
  const fetchFilter = encodeURI(`(eventid=${session.eventid})`);
  const orderby = _.isEqual(extra?.sortBy, 'randomly')
    ? FETCH_ORDERS.exhibitor.random
    : FETCH_ORDERS.exhibitor.name;
  const fetchOrder =
    OVERVIEW_FEATURE_FETCH_LIMITS[ALLOWED_FEATURE_KEYS.exhibitor];
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.exhibitors}?include_count=true&fields=${FIELDS.exhibitors.maxInfo}&filter=${fetchFilter}&order=${orderby}&limit=${fetchOrder}&offset=0`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        dispatch({
          type: ALL_EXHIBITORS_LIST,
          payload: { resource: res.resource, count: res.meta.count }
        });
        callback && callback({ success: 1 });
      },
      error => {
        callback && callback({ success: 0 });
      }
    );
  };
};

export const fetchAllSessions_Overview = (
  session,
  extra = { appTabId: 0, schedulesData },
  callback = null
) => {
  const tracks = _.chain(extra?.schedulesData?.data)
    .flatMap(ea => ea?.ScheduleDateToScheduletracks)
    .map('scheduletrackid')
    .join(', ')
    .value();

  if (_.isEmpty(tracks))
    return dispatch => callback && callback({ success: 1 });

  const fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(apptabid=${extra?.appTabId})AND(scheduletrackid IN (${tracks})))`
  );
  const sessionTableFields = `speaker_by_speakerid,speaker_by_sessionspeakers,interactivemaps_by_interactivemaplocation_session_link&speaker_by_speakerid.fields=${FIELDS.speaker.minInfo}&speaker_by_sessionspeakers.fields=${FIELDS.speaker.minInfo}&interactivemaps_by_interactivemaplocation_session_link.fields=interactivemapid`;
  const orderBy = FETCH_ORDERS.session;
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?include_count=true&fields=${FIELDS.session.mediumInfo}&related=${sessionTableFields}&filter=${fetchFilter}&order=${orderBy}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        dispatch({
          type: ALL_SESSION_LIST,
          payload: { resource: res.resource, count: res.meta.count }
        });
        callback && callback({ success: 1 });
      },
      error => {
        callback && callback({ success: 0 });
      }
    );
  };
};

export const setSeenAds = adlist => {
  return dispatch => {
    dispatch({ type: SEEN_EVENT_ADS, payload: adlist });
  };
};
